// Consent wording shown to people, with the version ids recorded as proof of
// consent. Each version here must be registered in web-server/domain/consent
// (consent.go, the wordings map) with identical text: the server rejects
// unknown versions. The two files are kept in step by hand; the server also
// keeps versions no screen shows any more, so old ledger rows stay valid.
// Changing the text means adding a new version on both sides, never editing an
// existing one.
export const MARKETING_EMAIL_CONSENT = {
    version: 'marketing_email.2026-10-20',
    lead: 'Help me make better site decisions.',
    text: 'Help me make better site decisions. Send me practical terrain-analysis tips, invitations to live site-read workshops, and exclusive LandScope offers. Unsubscribe anytime.',
};
export const AD_AUDIENCE_CONSENT = {
    version: 'ad_audience.2026-10-19',
    text: 'I agree that LandScope may use my email address and selected professional information to create advertising audiences and show me relevant LandScope advertising on platforms such as Meta. I can withdraw this permission by contacting admin@landscope.earth or using the privacy controls in Settings.',
};
// Splits wording into its bold lead and the remainder for display.
export const splitConsentWording = (w) => {
    if (w.lead && w.text.startsWith(w.lead)) {
        return { lead: w.lead, rest: w.text.slice(w.lead.length) };
    }
    return { lead: '', rest: w.text };
};
// Builds the ConsentWordingVersions proto naming exactly the text displayed.
export const buildConsentWordingVersions = (protoModule) => {
    const versions = new protoModule.ConsentWordingVersions();
    versions.setMarketingEmail(MARKETING_EMAIL_CONSENT.version);
    versions.setAdAudience(AD_AUDIENCE_CONSENT.version);
    return versions;
};
